import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      // Inert: do not enable. V2 commits to dark-only as the active
      // posture. The light + noticiasLight themes are preserved as historical
      // config (original palettes for a future light-mode project), not
      // maintained against V2 tokens. Enabling them today would surface
      // hundreds of un-audited rgba(255, 255, 255, …) overlays.
      light: {
        primary: '#00E074',
        background_primary: '#FFFFFF',
        background_secondary: '#F1F3F5',
        surface_primary: '#FFFFFF',
        surface_secondary: '#F5F5F5',
        surface_tertiary: '#EEEEEE',
        surface_hover: '#EEEEEE',
        surface_selected: '#9E9E9E',
        surface_neutral_selected: '#EEEEEE',
        surface_neutral_default: '#CCCCCC',
        surface_error_default: '#D36561',
        table_header_bg: '#CCCCCC',
        table_header_text: '#171717',
        table_data_bg: '#F5F5F5',
        common_text: '#171717',
        text_primary: '#171717',
        text_secondary: '#323232',
        text_inverse: '#FFFFFF',
        text_action_default: '#FFFFFF',
        accent: '#82B1FF',
        error: '#CA2E24',
        info: '#2AB0FC',
        success: '#38C976',
        warning: '#FCC132',
        icon_default: "#171717",
        icon_selected: '#616161',
        icon_action_default: '#101010',
        border_default: "#E0E0E0"
      },
      dark: {
        primary: '#00E074',
        on_primary: '#0a0a0a',
        background_primary: '#141518',
        background_secondary: '#1A1E20',
        surface_primary: '#1F1F1F',
        table_header_bg: '#262626',
        table_header_text: '#00E074',
        table_data_bg: '#1F1F1F',
        surface_secondary: '#171717',
        surface_tertiary: '#1F1F1F',
        surface_hover: '#1A1E20',
        surface_selected: '#000000',
        surface_neutral_selected: '#424242',
        surface_neutral_default: '#262626',
        surface_error_default: '#D36561',
        common_text: '#171717',
        text_primary: '#FFFFFF',
        text_secondary: '#A1A1A3',
        text_inverse: '#1A1E20',
        text_action_default: '#FFFFFF',
        accent: '#82B1FF',
        error: '#CA2E24',
        info: '#2AB0FC',
        success: '#38C976',
        warning: '#FCC132',
        icon_default: "#FFFFFF",
        icon_action_default: '#FFFFFF',
        border_default: "#616161",
      },
      noticiasDark: {
        primary: '#7AB9FF',
        on_primary: '#0a0a0a',
        background_primary: '#141518',
        background_secondary: '#1A1E20',
        surface_primary: '#1F1F1F',
        table_header_bg: '#262626',
        table_header_text: '#00E074',
        table_data_bg: '#1F1F1F',
        surface_secondary: '#171717',
        surface_tertiary: '#1F1F1F',
        surface_hover: '#1A1E20',
        surface_selected: '#000000',
        surface_neutral_selected: '#424242',
        surface_neutral_default: '#262626',
        surface_error_default: '#D36561',
        common_text: '#171717',
        text_primary: '#FFFFFF',
        text_secondary: '#A1A1A3',
        text_inverse: '#1A1E20',
        text_action_default: '#FFFFFF',
        accent: '#82B1FF',
        error: '#CA2E24',
        info: '#2AB0FC',
        success: '#38C976',
        warning: '#FCC132',
        icon_default: "#FFFFFF",
        icon_action_default: '#FFFFFF',
        border_default: "#616161",
      },
      // Inert: do not enable. See note above .light theme.
      noticiasLight: {
        primary: '#7AB9FF',
        background_primary: '#FFFFFF',
        background_secondary: '#F1F3F5',
        surface_primary: '#FFFFFF',
        surface_secondary: '#F5F5F5',
        surface_tertiary: '#EEEEEE',
        surface_hover: '#EEEEEE',
        surface_selected: '#9E9E9E',
        surface_neutral_selected: '#EEEEEE',
        surface_neutral_default: '#CCCCCC',
        surface_error_default: '#D36561',
        table_header_bg: '#CCCCCC',
        table_header_text: '#171717',
        table_data_bg: '#F5F5F5',
        common_text: '#171717',
        text_primary: '#171717',
        text_secondary: '#323232',
        text_inverse: '#FFFFFF',
        text_action_default: '#FFFFFF',
        accent: '#82B1FF',
        error: '#CA2E24',
        info: '#2AB0FC',
        success: '#38C976',
        warning: '#FCC132',
        icon_default: "#171717",
        icon_selected: '#616161',
        icon_action_default: '#101010',
        border_default: "#E0E0E0"
      }
    },
    options: {
      customProperties: true
    }
  },
});
